module.exports = __webpack_public_path__ + "static/media/scannerimg1.ce6d84da.svg";